import { uapiFetcher } from 'util/UAPI';
import {
  SeedDensityRecommendationInput,
  SeedDensityRecommendationQueryResponse
} from '../../types';
import { SEED_DENSITY_RECOMMENDATION } from './queries';
import { trackError } from 'util/error';

const headers = { 'X-feature-flag': 'test_preceon_recommendations' };

export const fetchSeedDensityRecommendation = async (input: SeedDensityRecommendationInput) => {
  try {
    return await uapiFetcher<SeedDensityRecommendationQueryResponse>(
      SEED_DENSITY_RECOMMENDATION, { input }, headers
    );
  } catch (error) {
    trackError(new TypeError('Could not fetch "seedDensityRecommendationJob" query from UAPI'), { error });
    throw error;
  }
};
